export default "__VITE_ASSET__DVtTjjvX__"